import { IpcRendererEvent } from 'electron'
import store from '@/store'
import { getModule } from 'vuex-module-decorators'
import layoutStore from '@/modules/shared/layout.store'
import userStore from '@/modules/auth/auth.store'
import integrationStore from '@/modules/integration/integration.store'
import requestLogin from '@/utils/requestLogin'
import { quitAndInstall } from '@/utils/autoUpdate'
import { MatchAPI } from '@/api/match'

export interface DownloadProgress {
  bytesPerSecond: number
  percent: number
  total: number
  transferred: number
}

export interface IntegrationCredentials {
  gamePort: number
  lcuPort: number
  token: string
  scheme: string
}

export default function listenElectronIpcEvents() {
  // if the app is not running on electron, just do nothing
  if (!isElectron()) {
    return
  }

  window.ipcRenderer.on(
    'redeem-team-token',
    async (event: IpcRendererEvent, teamToken: string) => {
      requestLogin(() => {
        const layoutModule = getModule(layoutStore, store)
        layoutModule.showTeamTokenDialogWithDefaultToken(teamToken)
      }).then()
    }
  )

  window.ipcRenderer.on(
    'update-download-progress',
    (event: IpcRendererEvent, progress: DownloadProgress) => {
      const layoutModule = getModule(layoutStore, store)
      layoutModule.setUpdateDownloadProgress(progress)
    }
  )

  window.ipcRenderer.on(
    'update-downloaded',
    async (event: IpcRendererEvent) => {
      const layoutModule = getModule(layoutStore, store)
      layoutModule.setUpdateDownloadProgress(null)
      await quitAndInstall()
    }
  )

  window.ipcRenderer.on(
    'auth-response',
    async (event: IpcRendererEvent, data: { status: string }) => {
      const userModule = getModule(userStore, store)
      await userModule.updateLoginState()
    }
  )
}

/**
 * Return whether the instance is currently in electron
 * @returns {boolean} Is electron environment
 */
export function isElectron() {
  return !!window.ipcRenderer
}
